'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.partial = undefined;

var _LayeredCache = require('./internal/LayeredCache');

var funcCache = void 0;
var prevFunc = void 0;
var prevCacheLayer = void 0;

/**
 * Creates a copy of `func` that's bound to the given args. E.g. `partial(func, a, b)(c)` is
 * equivalent to `func(a, b, c)`.
 * @param {Function} func
 * @param  {...any} args
 * @return {Function}
 */
var partial = exports.partial = function partial(func) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (args.length === 0) return func;
  if (!funcCache) funcCache = new WeakMap();

  var cacheLayer = void 0;
  if (func === prevFunc) {
    // Optimize for the case where we're called repeatedly with the same func
    cacheLayer = prevCacheLayer;
  } else {
    cacheLayer = funcCache.get(func);
    if (!cacheLayer) {
      cacheLayer = new _LayeredCache.CacheLayer();
      funcCache.set(func, cacheLayer);
    }
  }
  prevFunc = func;
  prevCacheLayer = cacheLayer;

  var partialFunc = (0, _LayeredCache.cacheGet)(cacheLayer, args);
  if (!partialFunc) {
    partialFunc = function partialFunc() {
      for (var _len2 = arguments.length, partialArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        partialArgs[_key2] = arguments[_key2];
      }

      return func.apply(undefined, args.concat(partialArgs));
    };
    (0, _LayeredCache.cachePut)(cacheLayer, args, partialFunc);
  }
  return partialFunc;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/core/Partials.js
// module id = 591
// module chunks = 171